import { render, staticRenderFns } from "./ProgramDescription.vue?vue&type=template&id=b7ab4338&"
import script from "./ProgramDescription.vue?vue&type=script&lang=js&"
export * from "./ProgramDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports